export enum ImportTypesEnum {
    Barcode,
    FileImport
}
